import { Chip, ChipProps } from '@mui/material';
import { alpha, getContrastRatio } from '@mui/material/styles';

// The light blue every tag showed in before tags had colors (CasChip's lightBlue). A tag
// with no Color of its own still shows in it.
export const DEFAULT_TAG_COLOR = '#cfe2f3';

export interface ICasTag {
  id: number;
  name: string;
  color?: string | null;
}

interface IProps extends Omit<ChipProps, 'label' | 'color' | 'sx'> {
  tag: Pick<ICasTag, 'name' | 'color'>;
}

/*
  A customer tag, drawn in its own color. Sized like a small CasChip, which is what tags used
  before. Other Chip props (onDelete, and the props an Autocomplete hands its selected-value
  chips) pass through.
*/
export default function CasTagChip({ tag, ...other }: IProps) {
  const backgroundColor = tag.color || DEFAULT_TAG_COLOR;
  // Black or white text, whichever stands out more against the tag's color.
  const color =
    getContrastRatio(backgroundColor, '#fff') > getContrastRatio(backgroundColor, '#000')
      ? '#fff'
      : '#000';

  return (
    <Chip
      label={tag.name}
      size="small"
      {...other}
      sx={{
        height: '16px',
        fontSize: '11px',
        color,
        backgroundColor,
        '&:hover, &.Mui-focusVisible': { backgroundColor },
        '& .MuiChip-label': { paddingLeft: '8px', paddingRight: '8px' },
        '& .MuiChip-deleteIcon': {
          color: alpha(color, 0.4),
          '&:hover': { color: alpha(color, 0.7) },
        },
      }}
    />
  );
}
